// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"653907210dfce89c","7702":"b6323009d4472833"}[chunkId] + ".css";
};